import { Delegate } from '@qualtrics/page-metrics/lib/metrics-emitter';
import { initializeMetricsObserver } from './metrics-observer';
import { initializeLogsObserver, initializeMetadata } from './log-observer';

let metricsDelegate;

let isMetricsInitialized = false;
let isRumMetaDataInitialized = false;
let isPreInitializationRumDataSet = false;
let isAppCompletePosted = false;

function initializeMetricsService() {
  if (!isMetricsInitialized) {
    metricsDelegate = new Delegate();
    initializeMetricsObserver(metricsDelegate);
    initializeLogsObserver(metricsDelegate);
    isMetricsInitialized = true;
  }
}

function initializeBaseRumMetaData(metadata) {
  if (!isPreInitializationRumDataSet) {
    initializeMetadata(metadata);
    isPreInitializationRumDataSet = true;
  }
}

function initializeRumMetaData(metadata) {
  if (!isRumMetaDataInitialized) {
    initializeMetadata(metadata);
    isRumMetaDataInitialized = true;
  }
}

function logBundleFailure(error, msg) {
  if (isMetricsInitialized) {
    metricsDelegate.raiseEvent('onBundleFailure', msg, {
      errorMsg: error?.message,
      status: error?.status,
    });
  }
  console.error(msg);
}

function logVisibilityEvalFailure(error, msg, contextType) {
  if (isMetricsInitialized) {
    metricsDelegate.raiseEvent('onVisibilityEvalFailure', msg, contextType, {
      status: error?.status,
      statusText: error?.statusText,
      errorMsg: error?.message,
      contextType,
      transactionId: error?.transactionId,
    });
  }
  console.error(msg);
}

function onAppInteractive() {
  if (!isAppCompletePosted && isMetricsInitialized) {
    metricsDelegate.raiseEvent('onAppInteractive');
  }
}

function onAppComplete() {
  if (!isAppCompletePosted && isMetricsInitialized) {
    metricsDelegate.raiseEvent('onAppComplete');
    isAppCompletePosted = true;
  }
}

function onProjectTypeDifference(projectType, resourceType, pageId) {
  metricsDelegate.raiseEvent(
    'error',
    'Inconsistent ProjectType and ResourceType',
    { projectType, resourceType, pageId },
  );
}

function logSessionStorageFailure(error, msg, additionalKeyPairs = {}) {
  if (isMetricsInitialized) {
    metricsDelegate.raiseEvent('onSessionStorageWriteFailure', msg, {
      errorMsg: error?.message,
      errorName: error?.name,
      ...additionalKeyPairs,
    });
  }
  console.error(msg);
}

function logStorageSnapshot(snapshot) {
  if (isMetricsInitialized) {
    metricsDelegate.raiseEvent('onStorageSnapshot', snapshot);
  }
}

function logAmplitudeRequest(amplitudeRequestLog) {
  if (isMetricsInitialized) {
    metricsDelegate.raiseEvent('onAmplitudeRequest', amplitudeRequestLog);
  }
}

export {
  initializeMetricsService,
  logAmplitudeRequest,
  logBundleFailure,
  logSessionStorageFailure,
  logStorageSnapshot,
  logVisibilityEvalFailure,
  onAppInteractive,
  onAppComplete,
  initializeRumMetaData,
  onProjectTypeDifference,
  initializeBaseRumMetaData,
};
